import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataSourceResponse, Doctor } from '../../models';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({
    providedIn: 'root',
})
export class DoctorService extends ApiService {
    endpoint = '/api/doctors';

    become(employeeId?: string) {
        let url = `${this.doctorBaseURL}${this.endpoint}/become`;
        if (employeeId) {
            url += `?employeeId=${employeeId}`;
        }
        return this.http.get<string>(url);
    }

    getByPersonId(personId: string): Observable<Doctor> {
        return this.http.get<Doctor>(`${this.doctorBaseURL}/api/doctors/person/${personId}`);
    }
    getDoctors(queryParams?: any): Observable<DataSourceResponse<Doctor>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.doctorBaseURL}${this.endpoint}`, { params });
    }
}
